import { GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS } from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
